const TEXT_BUTTON_LINK = "text-button-link";
const WEB_LINK = "web-link";
const ANCHOR_LINK = "anchor-link";
const LINK_PLUGIN_DISPLAY_AS_LINK_PREVIEW_BUTTON = "display-as-link-preview-button";
const LINK_PLUGIN_REMOVE_BUTTON = "remove-link-button";
const LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON = "scroll-to-anchor-button";
export {
  ANCHOR_LINK,
  LINK_PLUGIN_DISPLAY_AS_LINK_PREVIEW_BUTTON,
  LINK_PLUGIN_REMOVE_BUTTON,
  LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON,
  TEXT_BUTTON_LINK,
  WEB_LINK
};
//# sourceMappingURL=data-hooks.js.map
